export const DOCUMENT_CONTENT_TYPE = {
    TEXT: 1,
    IMAGE: 2,
    AUDIO: 3,
    VIDEO: 4
};
